import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { getSearchBarColumnHeaders } from '../utils';

const SearchBarTableHeader = ({ model }) => {
  const tableConfig = getSearchBarColumnHeaders(model);

  const headers = get(tableConfig, 'headers', [])
    .map((column, key) => (
      <th
        className="search-result__column"
        key={`${model}-column-header-${key}`}
        role="columnheader"
        scope="col"
        aria-label={column.ariaLabel}
      >
        {column.label}
      </th>
    ));

  return (
    <tr className="search-results-section-header" role="row">
      {headers}
    </tr>
  );
};

SearchBarTableHeader.propTypes = {
  model: PropTypes.string.isRequired,
};

export default SearchBarTableHeader;
